import type { JSX } from 'react';
import type { UseFormRegister, FieldErrors } from 'react-hook-form';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import type { EducationFormData } from './EducationFormFields';

interface YearFieldsProps {
  register: UseFormRegister<EducationFormData>;
  errors: FieldErrors<EducationFormData>;
}

export function YearFields({ register, errors }: YearFieldsProps): JSX.Element {
  return (
    <div className="grid grid-cols-2 gap-4">
      <div className="space-y-2">
        <Label htmlFor="yearBegin">
          Year Begin <span className="text-destructive">*</span>
        </Label>
        <Input
          id="yearBegin"
          type="number"
          placeholder="2015"
          {...register('yearBegin', { required: 'Year begin is required' })}
        />
        {errors.yearBegin && <p className="text-sm text-destructive">{errors.yearBegin.message}</p>}
      </div>
      <div className="space-y-2">
        <Label htmlFor="yearEnd">Year End</Label>
        <Input id="yearEnd" type="number" placeholder="2019" {...register('yearEnd')} />
        {errors.yearEnd && <p className="text-sm text-destructive">{errors.yearEnd.message}</p>}
      </div>
    </div>
  );
}
